import type { Participant } from '../../types'

interface TypingIndicatorProps {
  participants: Participant[]
  currentParticipantId: string
}

export default function TypingIndicator({ participants, currentParticipantId }: TypingIndicatorProps) {
  const typing = participants.filter(p => p.isTyping && p.id !== currentParticipantId)

  if (typing.length === 0) return null

  const names = typing.map(p => p.displayName).join(', ')
  const verb = typing.length === 1 ? 'is' : 'are'

  return (
    <div className="px-4 py-1.5 mono-label text-navy/70" aria-live="polite">
      {names} {verb} typing
      <span className="caret" aria-hidden="true" />
    </div>
  )
}
